import { getCompanyId } from '@/utils/getCompanyId'


const productProfileMapping = (data, state) => {
	const companyId = getCompanyId()
	//shapeProfile, companyId, productId
	
	console.log('productProfileMapping', data?.priceModel, data, state)
	return {
		name: data?.product_profile?.product_profile_name,
		company_id: companyId,
		description: data?.product_profile?.description,
		user_scan_script: data?.product_profile?.user_scan_script?.replace(/[\t\n\r]/g, ' '),
		product_id: state.product.productId,
		segmentation_length: 1.0, //not needed in UI, need Super Admin access later
		lumia_lase_script: data?.product_profile?.lumia_lase_script,
		parameters: data?.product_profile?.job_parameters,
		shape_profile: state.createShapeProfile,
		id: state.product.profileId,
		
		pricing_id: data?.pricing,
	}
}
export default productProfileMapping
